var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v(" "+_vm._s(_vm.myPriceWithCurrency)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }